import * as pc from "playcanvas";

const addPointMarker = (app, position, modelConfig) => {

    let color = new pc.Color(1, 1, 1);
    
    // Create a new entity for the point marker
    const marker = new pc.Entity();
    
    // Create a sphere mesh for visualization
    const sphere = pc.createSphere(app.graphicsDevice, {
        radius: 0.1 * modelConfig.scale_factor
    });
    
    // Create and initialize the material
    const material = new pc.StandardMaterial();
    material.diffuse = color;
    material.update();
    
    // Add render component with initialized material
    marker.addComponent('render', {
        material: material,
        meshInstances: [new pc.MeshInstance(sphere, material)]
    });

    // Set position
    marker.setPosition(position.x, position.y, position.z);
    
    // Add to scene
    app.root.addChild(marker);
    
    return marker;
};

export const displayHotspots = (coordinatesArray, modelConfig, appRef) => {
    // console.log(appRef, "appRef");
    if (!appRef.current) return;
    
    // Create a position vector from the input coordinates
    const position = new pc.Vec3(
        coordinatesArray[0] * modelConfig.scale_factor,
        coordinatesArray[1] * modelConfig.scale_factor,
        coordinatesArray[2] * modelConfig.scale_factor
    );
    
    // Add the point marker to the scene
    const marker = addPointMarker(appRef.current, position, modelConfig);
    
    // Optional: Store the marker reference if you need to remove it later
    return marker;
};